{
  "R": [
    0, 245, 205, 120, 196, 220, 230, 0, 122, 236, 12, 204, 42, 119, 220, 103,
    60, 255, 165, 160, 0, 245, 205, 120, 196, 220, 230, 0, 122, 236, 13, 220,
    103, 255, 165, 160, 0, 120, 200, 255, 255, 164, 164, 164, 234, 0, 0, 0, 0, 0
  ],
  "G": [
    0, 245, 62, 18, 58, 248, 148, 118, 186, 13, 48, 182, 204, 159, 216, 255, 60,
    165, 42, 32, 200, 245, 62, 18, 58, 248, 148, 118, 186, 13, 48, 216, 255,
    165, 42, 32, 200, 190, 70, 148, 148, 108, 108, 108, 169, 0, 0, 0, 0, 0
  ],
  "B": [
    0, 245, 78, 134, 250, 164, 34, 14, 220, 176, 255, 142, 164, 176, 20, 255,
    60, 0, 42, 240, 200, 245, 78, 134, 250, 164, 34, 14, 220, 176, 255, 20, 255,
    0, 42, 240, 221, 150, 255, 10, 10, 226, 226, 226, 30, 64, 112, 160, 208, 255
  ],
  "A": [
    0, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64,
    64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64
  ],
  "I": [
    0, 2, 3, 4, 5, 7, 8, 10, 11, 12, 13, 14, 15, 16, 17, 18, 24, 26, 28, 30, 31,
    41, 42, 43, 44, 46, 47, 49, 50, 51, 52, 53, 54, 58, 60, 62, 63, 72, 77, 78,
    79, 80, 81, 82, 85, 251, 252, 253, 254, 255
  ]
}
